import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import TextScramble from '../components/TextScramble';
import { Eye, EyeOff } from 'lucide-react';

export default function LoginPage() {
  const { login } = useCustomerAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/account');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen pt-24 sm:pt-28 pb-24 flex items-center justify-center">
      <div className="w-full max-w-md px-4">
        <div className="text-center mb-12">
          <TextScramble
            text="Connexion"
            className="text-4xl sm:text-5xl tracking-tighter font-light text-black"
            delay={0.2}
          />
          <p className="mt-3 text-sm text-black/40">
            Pas encore de compte ?{' '}
            <Link to="/register" data-testid="go-to-register" className="underline text-black/70 hover:text-black transition-colors">
              Cr&eacute;er un compte
            </Link>
          </p>
        </div>

        {error && (
          <div data-testid="login-error" className="mb-6 p-3 text-sm text-center" style={{ backgroundColor: '#B800000D', color: '#B80000' }}>
            {error}
          </div>
        )}

        <form data-testid="login-form" onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-bold text-black/40 block mb-2">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={form.email}
              onChange={e => setForm({...form, email: e.target.value})}
              required
              className="bg-transparent border-b border-black/20 focus:border-black outline-none py-3 w-full text-sm transition-colors"
              placeholder="votre@email.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-bold text-black/40 block mb-2">Mot de passe</label>
            <div className="relative">
              <input
                data-testid="login-password"
                type={showPass ? 'text' : 'password'}
                value={form.password}
                onChange={e => setForm({...form, password: e.target.value})}
                required
                className="bg-transparent border-b border-black/20 focus:border-black outline-none py-3 w-full text-sm transition-colors pr-10"
                placeholder="Votre mot de passe"
              />
              <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-0 top-3 text-black/30 hover:text-black/60">
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            <div className="mt-2 text-right">
              <Link
                to="/forgot-password"
                data-testid="forgot-password-link"
                className="text-[11px] uppercase tracking-[0.2em] font-bold text-black/40 hover:text-black transition-colors"
              >
                Mot de passe oublié ?
              </Link>
            </div>
          </div>

          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={loading}
            className="btn-primary w-full mt-8"
          >
            {loading ? 'Connexion...' : 'Se Connecter'}
          </button>
        </form>
      </div>
    </div>
  );
}
